import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import {
  getCategoryMeta,
  getProductsByCategory,
  CATEGORY_HERO_IMAGES,
} from "../data/products";
import ProductCard from "../components/ProductCard";
import usePageMeta from "../hooks/usePageMeta";

const Category = () => {
  const { id } = useParams();
  const meta = getCategoryMeta(id);
  usePageMeta(
    meta ? `${meta.name} · 67Cafe` : "Category · 67Cafe",
    meta
      ? `Browse pretend ${meta.name.toLowerCase()} in the 67Cafe kids' store. ${meta.tagline}`
      : "Browse a category on 67Cafe"
  );
  if (!meta) return <Navigate to="/shop" replace />;
  const items = getProductsByCategory(id);

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-6 sm:py-8" data-testid={`category-page-${id}`}>
      <Link
        to="/shop"
        className="btn-3d btn-sm btn-ghost mb-4"
        data-testid="category-back-btn"
      >
        <ArrowLeft size={18} strokeWidth={3} /> Back
      </Link>

      <div
        className="chunky-card p-5 sm:p-8 flex items-center gap-4 sm:gap-6 relative overflow-hidden"
        style={{ background: meta.color + "22" }}
      >
        <img
          src={CATEGORY_HERO_IMAGES[meta.id]}
          alt={`${meta.name} - ${meta.tagline}`}
          aria-hidden="true"
          className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-25"
          loading="lazy"
        />
        <div
          className="relative rounded-full flex items-center justify-center shrink-0"
          style={{
            width: 96,
            height: 96,
            background: meta.color,
            border: "3px solid #2b2b2b",
            boxShadow: "0 5px 0 #2b2b2b",
          }}
        >
          <span className="text-5xl bob" aria-hidden="true">
            {meta.emoji}
          </span>
        </div>
        <div className="relative">
          <h1 className="font-display text-3xl sm:text-4xl" data-testid="category-title">
            {meta.name}
          </h1>
          <p className="text-base sm:text-lg" style={{ color: "#484848" }}>
            {meta.tagline}
          </p>
        </div>
      </div>

      <div
        className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6"
        data-testid="category-products-grid"
      >
        {items.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </div>
  );
};

export default Category;
